import { TOKEN_LOCAL_STORAGE_KEY } from './constants';
import { LocalStorage } from './storage';
import type { IToken } from './types';

/**
 * Retrieves the access token from localStorage
 * @returns The access token string or null if not found
 */
export const getAccessToken = (): string | null => {
  const token = LocalStorage.get(TOKEN_LOCAL_STORAGE_KEY) as IToken | null;
  return token?.accessToken ?? null;
};

/**
 * Retrieves the refresh token from localStorage
 * @returns The refresh token string or null if not found
 */
export const getRefreshToken = (): string | null => {
  const token = LocalStorage.get(TOKEN_LOCAL_STORAGE_KEY) as IToken | null;
  return token?.refreshToken ?? null;
};

/**
 * Retrieves the full token object from localStorage
 * @returns The token object or null if not found
 */
export const getToken = (): IToken | null => {
  return LocalStorage.get(TOKEN_LOCAL_STORAGE_KEY) as IToken | null;
};

/**
 * Stores the token object in localStorage
 * @param token - The token object to store
 */
export const setTokenStorage = (token: IToken): void => {
  LocalStorage.set(TOKEN_LOCAL_STORAGE_KEY, token);
};

/**
 * Removes the token from localStorage
 */
export const removeToken = (): void => {
  LocalStorage.remove(TOKEN_LOCAL_STORAGE_KEY);
};
